import { get } from "@insite/client-framework/Services/ApiService";

export interface GetFreightCostResultModel {
    States?: string;
    Tier_10_000_?: string;
    Tier_5_000__9_999?: string;
    Tier_2_000__4_999?: string;
    Tier_1_000__1_999?: string;
    Tier_350__999?: string;
    Tier_0__349?: string;
}

export type GetFreightCostResult = GetFreightCostResultModel[];

// export interface GetFreightCostParameter extends ApiParameter{
//     StateCode:string
// }

export const GetFreightCostUrl = "api/v2/freightcost";

export async function GetFreightCost() {
    const response = await get<GetFreightCostResult[]>(GetFreightCostUrl);
    return response;
}
